{
  "ATTRIBUTES_MGMT": {
    "HEADER": "ویژگی‌های سفارشی",
    "HEADER_BTN_TXT": "اضافه کردن ویژگی سفارشی",
    "LOADING": "واکشی ویژگی‌های سفارشی",
    "DESCRIPTION": "A custom attribute tracks additional details about your contacts or conversations—such as the subscription plan or the date of their first purchase. You can add different types of custom attributes, such as text, lists, or numbers, to capture the specific information you need.",
    "LEARN_MORE": "Learn more about custom attributes",
    "COUNT": "{n} attribute | {n} attributes",
    "SEARCH_PLACEHOLDER": "جستجو ویژگی ها...",
    "NO_RESULTS": "No attributes found matching your search",
    "ATTRIBUTE_MODELS": {
      "CONVERSATION": "گفتگو",
      "CONTACT": "مخاطب",
      "COMPANY": "شرکت"
    },
    "ATTRIBUTE_TYPES": {
      "TEXT": "متن",
      "NUMBER": "شماره",
      "LINK": "پیوند",
      "DATE": "Date",
      "LIST": "فهرست",
      "CHECKBOX": "چک باکس"
    },
    "ADD": {
      "TITLE": "اضافه کردن ویژگی سفارشی",
      "SUBMIT": "ايجاد كردن",
      "CANCEL_BUTTON_TEXT": "انصراف",
      "FORM": {
        "NAME": {
          "LABEL": "نمایش نام",
          "PLACEHOLDER": "نام نمایشی ویژگی سفارشی را وارد کنید",
          "ERROR": "نام الزامی است"
        },
        "DESC": {
          "LABEL": "توضیحات",
          "PLACEHOLDER": "توضیحات ویژگی سفارشی را وارد کنید",
          "ERROR": "توضیحات الزامی است"
        },
        "MODEL": {
          "LABEL": "شامل",
          "PLACEHOLDER": "لطفا یکی را انتخاب کنید",
          "ERROR": "مدل مورد نیاز است"
        },
        "TYPE": {
          "LABEL": "نوع",
          "PLACEHOLDER": "لطفا نوع دسترسی اپراتور را مشخص کنید",
          "ERROR": "نوع الزامی است",
          "LIST": {
            "LABEL": "لیست مقادیر",
            "PLACEHOLDER": "لطفا مقدار را وارد کنید و کلید enter را فشار دهید",
            "ERROR": "باید حداقل یک مقدار داشته باشد"
          }
        },
        "KEY": {
          "LABEL": "کلید",
          "PLACEHOLDER": "کلید ویژگی سفارشی را وارد کنید",
          "ERROR": "کلید الزامی است",
          "IN_VALID": "کلید نامعتبر"
        },
        "REGEX_PATTERN": {
          "LABEL": "الگوی رجکس",
          "PLACEHOLDER": "لطفا الگوی رجکس ویژگی سفارشی را وارد کنید. (اختباری)"
        },
        "REGEX_CUE": {
          "LABEL": "Regex Cue",
          "PLACEHOLDER": "لطفا توضیحات مربوط به الگوری رجکس را وارد کنید. (اختیاری)"
        },
        "ENABLE_REGEX": {
          "LABEL": "فعال سازی بررسی رجکس"
        },
        "BADGES": {
          "PRE_CHAT": "Pre-chat",
          "RESOLUTION": "Resolution"
        }
      },
      "API": {
        "SUCCESS_MESSAGE": "ویژگی سفارشی با موفقیت اضافه شد!",
        "ERROR_MESSAGE": "نمی‌توان یک ویژگی سفارشی ایجاد کرد. لطفا بعدا دوباره امتحان کنید."
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "حذف",
      "API": {
        "SUCCESS_MESSAGE": "ویژگی سفارشی با موفقیت حذف شد.",
        "ERROR_MESSAGE": "ویژگی سفارشی حذف نشد. دوباره امتحان کنید."
      },
      "CONFIRM": {
        "TITLE": "آیا مطمئن هستید که می خواهید حذف کنید - {attributeName}",
        "PLACE_HOLDER": "برای تایید لطفا {attributeName} را تایپ کنید",
        "MESSAGE": "با حذف ویژگی، ویژگی سفارشی به طور کامل حذف می‌شود",
        "YES": "حذف ",
        "NO": "انصراف"
      }
    },
    "EDIT": {
      "TITLE": "ویرایش ویژگی سفارشی",
      "UPDATE_BUTTON_TEXT": "اعمال شود",
      "TYPE": {
        "LIST": {
          "LABEL": "لیست مقادیر",
          "PLACEHOLDER": "لطفا مقادیر را وارد کنید و کلید enter را فشار دهید"
        }
      },
      "API": {
        "SUCCESS_MESSAGE": "ویژگی سفارشی با موفقیت به‌روزرسانی شد",
        "ERROR_MESSAGE": "هنگام به‌روزرسانی ویژگی سفارشی خطایی روی داد، لطفا دوباره امتحان کنید"
      }
    },
    "TABS": {
      "HEADER": "ویژگی‌های سفارشی",
      "CONVERSATION": "گفتگو",
      "CONTACT": "مخاطب",
      "COMPANY": "شرکت"
    },
    "LIST": {
      "TABLE_HEADER": {
        "NAME": "نام",
        "DESCRIPTION": "توضیحات",
        "TYPE": "نوع",
        "KEY": "کلید"
      },
      "BUTTONS": {
        "EDIT": "ویرایش",
        "DELETE": "حذف"
      },
      "EMPTY_RESULT": {
        "404": "هیچ ویژگی سفارشی ایجاد نشده است",
        "NOT_FOUND": "هیچ ویژگی سفارشی پیکربندی نشده است"
      },
      "REGEX_PATTERN": {
        "LABEL": "الگوی رجکس",
        "PLACEHOLDER": "لطفا الگوی رجکس ویژگی سفارشی را وارد کنید. (اختباری)"
      },
      "REGEX_CUE": {
        "LABEL": "Regex Cue",
        "PLACEHOLDER": "لطفا توضیحات مربوط به الگوری رجکس را وارد کنید. (اختیاری)"
      },
      "ENABLE_REGEX": {
        "LABEL": "فعال سازی بررسی رجکس"
      }
    },
    "BADGES": {
      "PRE_CHAT": "Pre-chat",
      "RESOLUTION": "Resolution"
    }
  }
}
